import type { InputHTMLAttributes, JSX, Ref } from "preact";
import { forwardRef } from "preact/compat";
import { classNames } from "@gss/common/classNames";

interface Props extends Omit<
    InputHTMLAttributes,
    "type" | "onChange" | "role"
> {
    className?: string;
    small?: boolean;
    invalid?: boolean;
    warning?: boolean;
    onChange?: (files: FileList | null) => void;
}

export const InputFile = forwardRef(
    (
        { className, small, invalid, warning, onChange, ...rest }: Props,
        ref: Ref<HTMLInputElement>,
    ): JSX.Element => {
        return (
            <input
                {...rest}
                ref={ref}
                type="file"
                className={classNames(
                    "form-control",
                    small && "form-control-sm",
                    invalid && "is-invalid",
                    warning && !invalid && "border-warning",
                    className,
                )}
                onChange={
                    onChange != null
                        ? (e) => onChange(e.currentTarget.files)
                        : undefined
                }
            />
        );
    },
);

InputFile.displayName = "InputFile";
